module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-logo', {
    attrs: {
      "title": "博客详情页"
    }
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(" 标题： " + _vm._s(_vm.blog.title) + "  ")]), _vm._v(" "), _c('p', [_vm._v(" 发布于： " + _vm._s(_vm.blog.created_at))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.blog.body)
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-94f72dde"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Blog.vue
// module id = 70
// module chunks = 0